import { FC, useContext, useMemo } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LocalizationContext } from 'src/Context/LocalizationContext';
import { refineFonts } from '@/Theming/refineFonts';
import { InvestigationContext } from '@context/InvestigationContext';
import { ExclamationMarkIcon } from '@icons/ExclamationMarkIcon';
import { IF } from '../IF';

interface ISubmitWithoutDocumentsDialogProps {
	isDialogOpen: boolean;
	setOpenDialog: Function;
	handleSubmit: Function;
}

export const SubmitWithoutDocumentsDialog: FC<ISubmitWithoutDocumentsDialogProps> = ({
	isDialogOpen,
	setOpenDialog,
	handleSubmit,
}) => {
	const { SubmittingWithoutFilesDialog } = useContext(LocalizationContext);
	const { investigationDetails } = useContext(InvestigationContext);
	const { Message, Title, SubmitAnywaysButton, GoBackButton, InternationalWireTitle } = SubmittingWithoutFilesDialog;
	const isInternationalWire = useMemo(
		() => Boolean(investigationDetails?.nextQuestion?.additionalOptions?.preCheckFileUploadCheckbox),
		[investigationDetails],
	);

	const handleClose = () => {
		setOpenDialog(false);
	};

	const handleComplete = () => {
		setOpenDialog(false);
		handleSubmit();
	};

	return (
		<div>
			<Dialog
				open={isDialogOpen}
				keepMounted
				onClose={handleClose}
				aria-describedby="add-supporting-documents-review-dialog-description"
				data-cy="pqSubmitWithoutAttachmentsDialog">
				<DialogTitle gap={'6px'} display={'flex'} component={'div'} alignItems={'center'}>
					<IF condition={isInternationalWire}>
						<>
							<ExclamationMarkIcon />
							{InternationalWireTitle}
						</>
					</IF>
					<IF condition={!isInternationalWire}>
						<>{Title}</>
					</IF>
				</DialogTitle>
				<DialogContent>
					<DialogContentText>{Message.replace('%1$s', 'Valley')}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						sx={{ color: '#000000DE', ...refineFonts.mediumRegular }}
						onClick={handleClose}
						data-cy="pqSubmitWithoutAttachmentsDialogGoBackButton">
						{GoBackButton}
					</Button>
					<Button
						sx={{ ...refineFonts.mediumRegular }}
						onClick={handleComplete}
						data-cy="pqSubmitWithoutAttachmentsDialogSubmitAnywaysButton">
						{SubmitAnywaysButton}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
